(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gaj-complete-look"] && !Shopify.designMode) return;
  try {
    
(() => {
  class GajCompleteLook extends HTMLElement {
    connectedCallback(){this.controller=new AbortController();document.addEventListener('gaj:variant-selected',event=>{const metal=event.detail.options.find(option=>/gold|platinum/i.test(option));if(metal)this.querySelectorAll('gaj-shopping-card').forEach(card=>card.selectMetal?.(metal));},{signal:this.controller.signal});}
    disconnectedCallback(){this.controller?.abort();}
  }
  if(!customElements.get('gaj-complete-look'))customElements.define('gaj-complete-look',GajCompleteLook);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaj-email-offer"]) return;
  try {
    
(() => {
  class GajEmailOffer extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.launcher = this.querySelector('.gaj-offer__launcher');
      this.form = this.querySelector('form');
      this.key = `gaj-email-offer-${this.dataset.offerKey}`;
      this.success = !!this.querySelector('[data-offer-success]');
      if (!this.dialog || !this.launcher || typeof this.dialog.showModal !== 'function') return;
      this.launcher.addEventListener('click', () => this.open(), options);
      this.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.write('local', 'dismissed', String(Date.now()));
        this.launcher.hidden = this.success;
      }, options);
      this.form?.addEventListener('submit', () => {
        this.write('session', 'pending', 'true');
        this.dialog.close();
      }, options);
      const isReturn = location.hash === '#GajWelcomeForm' || this.read('session', 'pending') === 'true';
      if (this.success && isReturn) {
        this.write('local', 'subscribed', 'true');
        this.write('session', 'pending', '');
        this.open();
        return;
      }
      if (this.querySelector('[data-offer-errors]') && isReturn) {
        this.write('session', 'pending', '');
        this.open();
        this.querySelector('[data-offer-errors]').focus();
        return;
      }
      if (this.dataset.subscribed === 'true' || this.read('local', 'subscribed') === 'true') return;
      this.timer = setTimeout(() => {
        this.launcher.hidden = false;
        const dismissed = Number(this.read('local', 'dismissed'));
        const cooldown = Number(this.dataset.cooldown) * 86400000;
        const seen = this.read('session', 'seen') === 'true';
        const editing = document.activeElement?.matches('input, textarea, select, [contenteditable="true"]');
        if (!seen && Date.now() - dismissed > cooldown && !editing && !document.hidden && !document.querySelector('dialog[open], .sf-cart-drawer.open')) this.open();
      }, (window.matchMedia('(max-width: 699px)').matches ? 3 : Number(this.dataset.delay)) * 1000);
    }
    read(storage, suffix) {
      try { return (storage === 'local' ? localStorage : sessionStorage).getItem(`${this.key}-${suffix}`) || ''; } catch (_) { return ''; }
    }
    write(storage, suffix, value) {
      try { (storage === 'local' ? localStorage : sessionStorage).setItem(`${this.key}-${suffix}`, value); } catch (_) {}
    }
    open() {
      if (this.dialog.open) return;
      this.write('session', 'seen', 'true');
      this.launcher.hidden = true;
      this.dialog.showModal();
      this.querySelector('[data-offer-success], #GajOfferEmail')?.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) this.dialog.close();
    }
  }
  if (!customElements.get('gaj-email-offer')) customElements.define('gaj-email-offer', GajEmailOffer);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaj-mens-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-gaj-men] [data-gaj-metal]');
  if (!button) return;
  const card = button.closest('.gaj-men__card');
  const image = card.querySelector('.gaj-men__product-image');
  if (image && button.dataset.image) {
    image.removeAttribute('srcset');
    image.src = button.dataset.image;
    image.alt = card.querySelector('h2').textContent.trim() + ' — ' + button.dataset.label;
  }
  card.querySelectorAll('[data-gaj-product-link]').forEach(link => { link.href = button.dataset.url; });
  card.querySelectorAll('[data-gaj-metal]').forEach(item => { item.setAttribute('aria-pressed', String(item === button)); });
  card.querySelector('.gaj-men__selected').textContent = button.dataset.label;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaj-shop-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const button = event.target.closest('[data-gaj-shop] [data-gaj-metal]');
  if (!button) return;
  const card = button.closest('.gaj-shop__card');
  const image = card.querySelector('.gaj-shop__product-image');
  if (image && button.dataset.image) {
    image.removeAttribute('srcset');
    image.src = button.dataset.image;
    image.alt = card.querySelector('h2').textContent.trim() + ' — ' + button.dataset.label;
  }
  card.querySelectorAll('[data-gaj-product-link]').forEach(link => { link.href = button.dataset.url; });
  card.querySelectorAll('[data-gaj-metal]').forEach(item => { item.setAttribute('aria-pressed', String(item === button)); });
  card.querySelector('.gaj-shop__selected').textContent = button.dataset.label;
  card.querySelector('.gaj-shop__price').textContent = button.dataset.price;
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
function gajSyncCollectionLinks(event) {
  const option = event.target.closest('pcard-swatch');
  if (!option) return;
  const card = option.closest('[data-gaj-gold-card]');
  if (!card) return;
  requestAnimationFrame(function() {
    const variantInput = card.querySelector('input[name="id"]');
    if (!variantInput || !/^\d+$/.test(variantInput.value)) return;
    card.querySelectorAll('[data-gaj-product-link]').forEach(function(link) {
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', variantInput.value);
      link.href = url.toString();
    });
    card.querySelectorAll('input[name="id"]').forEach(function(input) {
      input.value = variantInput.value;
      input.dataset.selectedVariant = variantInput.value;
    });
  });
}
document.addEventListener('click', gajSyncCollectionLinks);
document.addEventListener('change', gajSyncCollectionLinks);

  } catch(e) { console.error(e); }
})();
})();
